import type { LocaleLanguage } from '@/lib/locale-context';

export const API_TYPES = [
  'artikel',
  'news',
  'podcast',
  'flash-talk',
  'edu-talk',
  'spin-win-contest',
];

export const LANGUAGES: { code: LocaleLanguage; label: string }[] = [
  { code: 'de', label: 'Deutsch (DE)' },
  { code: 'en', label: 'English (EN)' },
];

// pluralization (adjust per API structure)
export const pluralMap: Record<string, string> = {
  artikel: 'artikels',
  news: 'news',
  podcast: 'podcasts',
  'flash-talk': 'flash-talks',
  'edu-talk': 'edu-talks',
  'spin-win-contest': 'spin-win-contests',
  pages: 'pages',
};
